import { Table, TableHead, TableBody, TableRow, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../../common/components';

const ConstructionTypesDataTable = ({ data, isLoading, onEdit, onDelete, LoadingComponent }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
            {data.map((item) => (
              <Box
                key={item.uuid}
                sx={{
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 2,
                  p: 2,
                  backgroundColor: theme.palette.background.paper,
                }}
              >
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                  {item.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Plan: {item.plan_name || '-'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Superficie: {item.surface ?? '-'} m2
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description || 'Sin descripción'}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mt: 1.5 }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(item)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(item)} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron tipos de construcción" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="construction types table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="25%">Plan</HeadTableCell>
            <HeadTableCell wmd="25%">Nombre</HeadTableCell>
            <HeadTableCell wmd="15%">Superficie (m2)</HeadTableCell>
            <HeadTableCell wmd="20%">Descripción</HeadTableCell>
            <HeadTableCell wmd="15%">Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((item) => (
              <TableRow key={item.uuid}>
                <RowTableCell>{item.plan_name || '-'}</RowTableCell>
                <RowTableCell>{item.name || '-'}</RowTableCell>
                <RowTableCell>{item.surface ?? '-'}</RowTableCell>
                <RowTableCell>{item.description || '-'}</RowTableCell>
                <RowTableCell align="center">
                  <ActionIconButton variant="edit" onClick={() => onEdit(item)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(item)} />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={5} message="No se encontraron tipos de construcción" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default ConstructionTypesDataTable;
